import { modeThemeClassic, } from './ModeThemeClassic';
import { modeThemeDefault, } from './ModeThemeDefault';
import { muiThemeDefault, } from './MUIThemeDefault';
import { modeThemeLight, modeThemeDark, } from './ModeThemeBizStack';
export * from './ModeThemeBase';
export * from './MUIThemeDefault';
export * from './ModeThemeClassic';
export * from './ModeThemeDefault';
export * from './ModeThemeBizStack';
export var ModeThemeType;
(function (ModeThemeType) {
    ModeThemeType["NONE"] = "none";
    ModeThemeType["DEFAULT"] = "";
    ModeThemeType["MODE_CLASSIC"] = "modeClassic";
    ModeThemeType["MODE_LIGHT"] = "modeLight";
    ModeThemeType["MODE_DARK"] = "modeDark";
})(ModeThemeType || (ModeThemeType = {}));
export const modeSupportedThemes = Object.freeze({
    [ModeThemeType.NONE]: {
        type: ModeThemeType.NONE,
        theme: muiThemeDefault,
    },
    [ModeThemeType.DEFAULT]: {
        type: ModeThemeType.DEFAULT,
        theme: modeThemeDefault,
    },
    [ModeThemeType.MODE_CLASSIC]: {
        type: ModeThemeType.MODE_CLASSIC,
        theme: modeThemeClassic,
    },
    [ModeThemeType.MODE_LIGHT]: {
        type: ModeThemeType.MODE_LIGHT,
        theme: modeThemeLight,
    },
    [ModeThemeType.MODE_DARK]: {
        type: ModeThemeType.MODE_DARK,
        theme: modeThemeDark,
    },
});
